export default __webpack_public_path__ + "static/Keating-2bfc35afcb8a345a5f7e7b8664cad280.jpg";